import { Component } from '@angular/core';

@Component({
  selector: 'app-subviews',
  templateUrl: './subviews.component.html',
  styleUrls: ['./subviews.component.scss']
})
export class SubviewsComponent {

}
